import api from '../config/api';

/**
 * Servicio para detalle de CTS (depósitos mayo y noviembre).
 * Cuando el backend exponga API de tabla detalle CTS, list/getById devolverán datos.
 */
const ctsService = {
  /**
   * Listar CTS guardados por empresa y año
   * GET /api/cts?empresa_id=&anio=
   */
  list: async (empresaId, anio) => {
    const response = await api.get('/cts', {
      params: { empresa_id: empresaId, anio },
    });
    return response.data;
  },

  /**
   * Obtener una CTS con su detalle (por empleado)
   * GET /api/cts/{id}
   */
  getById: async (id) => {
    const response = await api.get(`/cts/${id}`);
    return response.data;
  },
};

export default ctsService;
